import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import {PageAccountInvites} from '../page-account-invites';

export interface AccountInvitesCompatProps {

}

@inject(deps) @observer
export class AccountInvitesCompat extends Component<AccountInvitesCompatProps> {
  render() {
    return (
      <PageAccountInvites
        model={{
          title: this.props.model.content.referralTitle,
          content: this.props.model.content.referralContent,
          cta: this.props.model.content.referralCTA
        }}
        referralURL={this.props.model.user.referralURL}
      />
    )
  }
}